import { __rest } from "tslib";
import React from 'react';
import { Button, ButtonPriority as PRIORITY } from 'wix-ui-tpa';
import { SlimArrowDownIcon } from '../../../icons/slim-arrow-icon';
import { st, classes } from './submit-button.st.css';
const SubmitButton = React.forwardRef((_a, ref) => {
    var { children, disabled, onClick, className } = _a, rest = __rest(_a, ["children", "disabled", "onClick", "className"]);
    return (React.createElement(Button, Object.assign({ ref: ref, className: st(classes.root, className), disabled: disabled, priority: PRIORITY.primary, onClick: disabled ? undefined : onClick, upgrade: true }, rest),
        React.createElement("div", { className: classes.buttonContent },
            children,
            React.createElement(SlimArrowDownIcon, { className: classes.icon }))));
});
export default SubmitButton;
//# sourceMappingURL=submit-button.js.map